import { onboardingAbandonmentDelayHoursSchema } from "@redotech/redo-onboarding-common/abandonment-notifications";
import * as z from "zod";

const onboardingAbandonmentNotificationsOutput = z.object({
  delayHours: onboardingAbandonmentDelayHoursSchema,
  enabled: z.boolean(),
});

export const getOnboardingAbandonmentNotifications = {
  name: "getOnboardingAbandonmentNotifications" as const,
  input: z.object({}),
  output: onboardingAbandonmentNotificationsOutput,
};

export const setOnboardingAbandonmentNotifications = {
  name: "setOnboardingAbandonmentNotifications" as const,
  input: onboardingAbandonmentNotificationsOutput,
  output: onboardingAbandonmentNotificationsOutput,
};
